/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Napíšte niečo…',
  'fabric.editor.editorAssistiveLabel': 'Hlavná oblasť obsahu, sem začnite zadávať text.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Otvoriť dialógové okno pomoci'
};